import React, { useEffect, useState } from 'react';
import { Button, Hidden, makeStyles } from '@material-ui/core';
import { AlertCircle as AlertCircleIcon } from "react-feather";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import { useRecoilState } from "recoil";
import {
  siteState,
  itemState,
  argState,
  pageState,
  pageNumState,
  catState
} from 'src/recoil';
import { useLocation } from "react-router-dom";
import NavBar from './NavBar';
import TopBar from './TopBar';
import Contents from './Contents';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 0,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    padding: '15px'
  },
  menuBtn: {
    position: 'absolute',
    top: 15,
    right: 15,
  },
  buttonWrapper: {
    textAlign: 'center'
  }
}));

// Component
const DashboardLayout = (props, {
  className,
  onMobileNavOpen,
  ...rest
}) => {
  const classes = useStyles();
  const [cats, setCats] = useState([
    {
      href: '/404',
      icon: AlertCircleIcon,
      title: 'Category',
      status: false
    }
  ]);
  const [isMobileNavOpen, setMobileNavOpen] = useState(true);
  const [date, setDate] = useState(new Date());
  const [keyword, setKeyword] = useState(null);
  const [args, setArgs] = useRecoilState(argState);
  const [items, setItems] = useRecoilState(itemState);
  const [perpage, setPerPage] = useRecoilState(pageNumState);
  const [page, setPage] = useRecoilState(pageState);
  const [site, setSite] = useRecoilState(siteState);
  const location = useLocation();

  // eslint-disable-next-line class-methods-use-this
  async function getData() {
    let kw = '';
    let cs = '';
    if (keyword === null || keyword === '') {
      kw = '';
    } else {
      kw = `&search=${keyword}`;
    }
    if (args.length !== 0) {
      cs = `&categories=${args.toString()}`;
    }
    const response = await axios({
      method: 'GET',
      url: `${site}/wp-json/wp/v2/posts/?_embed&status=publish&per_page=${perpage}&page=${page}${kw}${cs}`,
      responseType: 'json'
    });
    return response;
  }

  // eslint-disable-next-line class-methods-use-this
  async function getCats() {
    const response = await axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      url: `${site}/wp-json/hangeulu/v1/term`,
      responseType: 'json'
    });
    return response;
  }

  function setCategorys(data) {
    // Category Setting
    setCats(data);
    // Page Reset
    setPage(1);
    // Args Setting
    const argsArray = [];
    data.forEach((item, index) => {
      if (item.status) {
        argsArray.push(item.term_id);
      }
    });
    setArgs(argsArray);
  }
  // eslint-disable-next-line class-methods-use-this
  function setKeywordFunction(e) {
    e.preventDefault();
    setKeyword(e.target.value);
    console.log(args);
  }

  // eslint-disable-next-line react/sort-comp
  async function pressEndter(e) {
    const key = e.keyCode;
    if (key === 13) {
      // Get Data
      getData().then((result) => {
        setItems(result.data);
      });
    }
  }

  // eslint-disable-next-line react/sort-comp
  function searchKeyword(e) {
    e.preventDefault();
    // Page Reset
    setPage(1);
    // Get Data
    getData().then((result) => {
      setItems(result.data);
    });
  }

  function moreItem(e) {
    // Page Setting
    // eslint-disable-next-line react/no-access-state-in-setstate
    const pageNumb = page + 1;
    setPage(pageNumb);
  }
  // Page
  useEffect(() => {
    // Get Data
    let itemsData;
    getData().then((result) => {
      if (result.data.length > 0) {
        result.data.forEach((data) => {
          setItems((oldList) => [
            ...oldList, data,
          ]);
        });
      }
    });
  }, [page]);

  // Default
  useEffect(() => {
    // 기본 카테고리
    getCats().then((result) => {
      const data = [];
      let index = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, item] of Object.entries(result.data)) {
        data[index] = item;
        data[index].title = item.name;
        data[index].status = false;
        data[index].href = `/app/${item.slug}`;
        data[index].slug = item.slug;
        index += 1;
      }
      setCats(data);
    });
    getData().then((result) => {
      setItems(result.data);
    });
  }, [location.pathname, site]);

  // Category
  useEffect(() => {
    // Get Data
    getData().then((result) => {
      setItems(result.data);
      console.log(result);
    });
  }, [args]);

  return (
    <div className={classes.root}>
      <Hidden lgUp>
        <TopBar
          site={site}
          onMobileNavOpen={() => setMobileNavOpen(true)}
        />
      </Hidden>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        cats={cats}
        site={site}
        keyword={keyword}
        setCats={setCategorys}
        setKeyword={setKeywordFunction}
        pressEndter={pressEndter}
        searchKeyword={searchKeyword}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Contents
              items={items}
              site={site}
            />
            <div className={classes.buttonWrapper}>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={moreItem}
                startIcon={<ExpandMoreIcon />}
              >
                More Content
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
